import { Reducer } from "redux";
import { MapActions } from "./mapActions";
import mapTypes from "./mapType";

export type TMapState = {
  defaultViewPort: {
    latitude: number;
    longitude: number;
    id: number;
    name: string;
  };
  viewportNew: {
    latitude: number;
    longitude: number;
  };
  address: "";
  city: "";
};

const initialState: TMapState = {
  defaultViewPort: {
    latitude: 35.69976003841564,
    longitude: 51.33808390275898,
    id: 129,
    name: "تهران",
  },
  viewportNew: {
    latitude: 35.69976003841564,
    longitude: 51.33808390275898,
  },
  address: "",
  city: "",
};

const mapReducer: Reducer<TMapState, MapActions> = (state = initialState, action) => {
  switch (action.type) {
    //   ----------setState
    case mapTypes.Set_Map_State:
      return {
        ...state,
        ...action.payload,
      };
    case mapTypes.Reset_Map_State:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default mapReducer;
